import { Component,
         OnInit } from '@angular/core';
import { CinchDataService } from "../../common/service/cinch-data.service";
import { UtilitiesService } from "../../common/service/utilities.service";
import { DashboardData } from "../../common/model/cinchAppViewData.model";

declare function require(url: string);
declare var jQuery:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    /**
     * TODO: Recommended future dev:
     *  - Set CMS variable on the dashboard view.
     *  - Rewrite dashboard data formatting as part of a service.
     * **/
 // Data sync variables
  viewData: DashboardData = {};
  dataIsSet = false;
  infoblockContainerClass = "myacc-infoblock-row--2-col";

  constructor( private util:UtilitiesService,
               private cinchData: CinchDataService) { }

  ngOnInit() {
    // Data sync

    this.cinchData.dashboardData$.subscribe(( dashboard ) => {
        this.dataIsSet = false;
        // console.log("DashboardComponent dashboardData$", dashboard);
        if (dashboard && dashboard.balance){
            this.viewData = dashboard;
            if ( dashboard.serviceHistory && (dashboard.serviceHistory.length > 0 )) {
                this.infoblockContainerClass = (dashboard.showCurrentBalance)?
                    "myacc-infoblock-row--2-1-col" : "myacc-infoblock-row--1-col";

            } else this.infoblockContainerClass = (dashboard.showCurrentBalance)?
                "myacc-infoblock-row--2-col" : "myacc-infoblock-row--1-col";

            jQuery(document).ready(function() {
                jQuery('[data-toggle="tooltip"]').tooltip();
            });
            this.dataIsSet = true;
        }
    } , e => console.log() );
  }

  goto( route ){
    this.util.goTo(route);
  }

}
